import {PlayButtonsDefaultBox} from './play-buttons.default.box';

export const PlayButtonsBox = PlayButtonsDefaultBox;